export const CPAAS_CUSTOMER_DETAILS_FIELDS = `
  id
  name
  level
  parentId
  accountNumber
  type

  # Voice features
  trunks {
    id
    name
    alias
  }
  netsapiensDomains {
    id
    name
    description
  }
  # Messaging
  smsEnabled
  smsConfigs {
    id
    name
    alias
    nnid {
      isA2p
    }
  }
  mmsEnabled
  mmsRoutes {
    id
    name
    alias
  }
  netsapiensEnabled
  netsapiensConfigId
  #Stir/Shaken
  shakenVerificationPolicyEnabled
  defaultNoIdentityHeaderPolicy
  defaultCertificateRepositoryErrorPolicy
  defaultInvalidIdentityHeaderPolicy
  #Inbound Cnam
  cnamDippingEnabled
  defaultValueCnamDippingEnabled
  reputationScoreEnabled
  defaultValueReputationEnable
  defaultReputationWarningScore
  defaultReputationWarningAction
  defaultReputationAlarmingScore
  defaultReputationAlarmingAction
`;